/**
 * Gets the appropriate image URL for a user/team member
 * 
 * @param {Object} member - The team member object
 * @param {Object} currentUser - The currently logged in user (from AuthContext)
 * @returns {string|null} The URL to use for the avatar, or null if no image is available
 */
export const getAvatarSrc = (member, currentUser) => {
  if (!member) return null;
  
  // Use member's picture if available
  if (member.picture_url) {
    return member.picture_url;
  }
  
  // Otherwise, use Google profile picture as fallback if emails match
  if (
    member.email && 
    currentUser && 
    member.email === currentUser.email && 
    currentUser.picture_url
  ) {
    return currentUser.picture_url;
  }
  
  // No image available
  return null;
}; 